var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length)?_c('div',{staticClass:"item-labels",attrs:{"id":"tags"}},_vm._l((_vm.tags),function(item,i){return _c('div',{key:i,staticClass:"item-labels-item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }